import React, { useState, useEffect } from 'react';

import {
  Box,
  Divider,
  TextField,
  Grid,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  styled,
  Card,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Chip,
  Checkbox,
  OutlinedInput,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';

import CommonBreadcumbs from '../../../../../components/common/CommonBreadcumbs';
import CommonSectionHeader from '../../../../../components/common/CommonSectionHeader';
import CommonRestricted from '../../../../../components/common/CommonRestricted';
import { CommonIcons, icons } from '../../../../../components/common/CommonIcons';

// import { spliceString } from '../../../../../utils/formatString';
import { mergeSchema, checkValueExists } from '../../../../../utils/dataSchema';
import { useAppContextFeatures } from '../../../../../context/AppContext';

import { useSystemPrompt } from '../../../../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes';
import { useRegions, regionTypes } from '../../../../../hooks/api/useRegions';
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';
import { useTranslations } from '../../../../../hooks/useTranslations';

import {
  // markingInjectionProps,
  branchDataTypes,
  initialValues as initialBranchValues,
  validationSchema as validationBranchSchema,
  useMarking
} from "../../../hooks/model/useMarking"

import {
  useCustomer,
  customerInjectionProps,
  initialValues,
  initialRowValues,
  initialPasswordValues,
  validationSchema,
  validationPasswordSchema,
} from "../../../hooks/model/useCustomer"

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export default function NewCustomer({ routeType }) {
  const { t } = useTranslations({ ns: ['common', '@user', '_prompt', '_common'] });

  const navigate = useNavigate();

  const { id } = useParams();
  const { getRoute } = useSystemRoutes(routeType);
  const { promptMessage } = useSystemPrompt();

  const { addMarking } = useMarking({ routeType })
  const { addCustomer, listCustomers, filterOperatorTypes } = useCustomer({ routeType })

  const { isPermissionAllow } = usePermissions(routeType, scopeIds.user.id, scopeTypes.user.customer.id);

  const { setSystemLoading } = useAppContextFeatures();

  const { list: listRegions } = useRegions({});
  const [dataCountries, setDataCountries] = useState([]);
  const [dataStates, setDataStates] = useState([]);
  const [dataAreas, setDataAreas] = useState([]);
  // const [currentMarking, setCurrentMarking] = useState();
  const { getHtmlHead } = useSystemHead(routeType);
  // const [customFields, setCustomFields] = useState([]);

  const validationSchemaCombine = mergeSchema(validationSchema, validationPasswordSchema, validationBranchSchema);

  const initialValuesCombine = {
    ...initialValues,
    ...initialPasswordValues,
    ...initialBranchValues,
  };

  const validateInputMarkings = async (props) => {
    const { markings } = props;

    // console.log('markings', markings)

    let allResponses = await Promise.all(
      markings.map(async (marking) => {
        const res = await fetchCustomers({ marking });
        return res;
      })
    );

    // console.log('allResponses', allResponses)

    let validateResults = [];

    // check all markings response
    allResponses.forEach((response, index) => {
      let isTaken = false;
      let isTakenBy = '';
      let marking = markings[index];

      response.forEach((i) => {
        if (i?.user_id !== id) {
          isTaken = true;
          isTakenBy = i?.user_id;
        }
      });

      validateResults.push({
        marking,
        isTaken,
        isTakenBy,
      });
    });

    // console.log('vali', validateResults)

    return validateResults;
  };

  const onSubmitBranch = async ({
    userId,
    currentValues,
    marking
  }) => {

    if (!userId) {
      promptMessage(false, `Invalid User Id.`);
      return false;
    }

    try {
      // let data = {
      //   branch: {
      //     branch_name: currentValues?.branchName,
      //     branch_code: currentValues?.branchCode,
      //     branch_contact: currentValues?.branchContact,
      //     branch_email: currentValues?.branchEmail,
      //     type: currentValues?.type,
      //     address_1: currentValues?.address1,
      //     address_2: currentValues?.address2,
      //     country_id: currentValues?.countryId,
      //     state_id: currentValues?.stateId,
      //     area_id: currentValues?.areaId,
      //     postcode: currentValues?.postcode,
      //     remark: currentValues?.remark,
      //     pic_name: currentValues?.picName,
      //     pic_contact: currentValues?.picContact,
      //     pic_email: currentValues?.picEmail,
      //     is_hq: currentValues?.isHQ ? 1 : 0,
      //   },
      //   props: {
      //     marking: '',
      //   },
      // };

      // const response = await createBranch({ id: userId, data });

      // return response?.data?.branch ? response.data.branch : {};

      let payload = {
        marking,
        customerUserId: userId,
        branch: {
          branchName: currentValues.branchName,
          branchCode: currentValues?.branchCode,
          branchContact: currentValues?.branchContact,
          branchEmail: currentValues?.branchEmail,
          type: currentValues?.type,
          address1: currentValues?.address1,
          address2: currentValues?.address2,
          countryId: currentValues?.countryId,
          stateId: currentValues?.stateId,
          areaId: currentValues?.areaId,
          postcode: currentValues?.postcode,
          remark: currentValues?.remark,
          picName: currentValues?.picName,
          picContact: currentValues?.picContact,
          picEmail: currentValues?.picEmail,
          isHQ: currentValues?.isHQ,
          status: 1
        }
      }

      let response = await addMarking(payload)

      return response

    } catch (error) {
      promptMessage(false, `Action Failed. (${error?.message})`);
    }

    return true;
  };

  const onSubmitCustomer = async ({ currentValues, inputMarkings }) => {
    try {

      const { rows } = values;

      // let cf = getSubmitFormDataFromRows({ rows })

      // let data = {
      //   credential: {
      //     username: currentValues?.username,
      //     password: currentValues?.password,
      //     firstname: currentValues?.firstname,
      //     lastname: currentValues?.lastname,
      //     contact: currentValues?.contactno,
      //     email: currentValues?.email,
      //     status: currentValues?.status ? 1 : 0,
      //   },
      //   customer: {
      //     reg_no: currentValues?.regno,
      //     company_name: currentValues?.companyname,
      //     code: currentValues?.code,
      //     account_code: currentValues?.accountcode,
      //     remark: currentValues?.remark,
      //   },
      //   props: {
      //     salesperson: currentValues?.salesperson,
      //   },
      // };

      // return await createUser({ data, targetType: targetTypes.customer });

      let payload = {
        inputMarkings,
        credential: {
          username: currentValues?.username,
          password: currentValues?.password,
          firstname: currentValues?.firstname,
          lastname: currentValues?.lastname,
          contact: currentValues?.contactno,
          email: currentValues?.email,
          status: currentValues?.status ? 1 : 0,
        },
        customer: {
          regNo: currentValues?.regno,
          companyName: currentValues?.companyname,
          code: currentValues?.code,
          accountCode: currentValues?.accountcode,
          remark: currentValues?.remark,
        },
        props: {
          salesperson: currentValues?.salesperson,
        },
      }

      return await addCustomer(payload)

      // promptMessage(true, `${response?.message}`)
      // navigate(getRoute("users/customers"))

    } catch (error) {
      promptMessage(false, `Action Failed. (${error?.message})`);
    }

    return true;
  };

  const onSubmit = async (currentValues) => {

    setSystemLoading(true);

    try {
      let inputMarkings = [];

      currentValues.rows.forEach((item) => {
        inputMarkings.push(item?.marking);
      });

      let validateMarkings = await validateInputMarkings({ markings: inputMarkings });

      let _totalTaken = validateMarkings.filter((i) => i.isTaken === true);
      let checkIsAllValid = _totalTaken.length === 0;

      if (checkIsAllValid === false) {
        promptMessage(false, `${_totalTaken.map((i) => i.marking).join(', ')} has been taken`);
        setSystemLoading(false);
        return false;
      }

      const response = await onSubmitCustomer({ currentValues, inputMarkings });

      const { user } = response?.data ? response.data : {};

      let responseCustomerBranch = {};

      if (user?.id) {
        responseCustomerBranch = await onSubmitBranch({
          userId: user?.id,
          currentValues,
          marking: inputMarkings[0]
        });
      }

      promptMessage(true, `${response?.message}`);
      // navigate(getRoute('users/customers'));

    } catch (error) {
      promptMessage(false, `Action Failed. (${error?.message})`);
    }
    setSystemLoading(false);
    return false;
  };

  const fetchCustomers = async ({ marking }) => {

    try {

      const props = {
        limit: 5,
        skip: 0,
        sortInfo: {
          id: 'id',
          dir: 0,
        },
        filterValue: [
          {
            name: customerInjectionProps.marking.retrieveKey,
            operator: filterOperatorTypes.havingInOr,
            value: JSON.stringify([marking]),
          },
        ],
      };

      const { data } = await listCustomers({
        props
      });

      return data

    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }

    return true;
  };

  const fetchDataCountry = async () => {
    try {
      const props = {
        limit: -1,
        offset: 0,
        filterValue: [],
        sortInfo: {
          id: 'country_name',
          dir: 0,
        },
      };

      props.regionType = regionTypes.country;

      const { data } = await listRegions(props);

      // console.log('re', data);

      setDataCountries(data?.countries);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }
  };

  const fetchDataStates = async (countryId) => {
    setDataStates([]);

    try {
      const props = {
        limit: -1,
        offset: 0,
        filterValue: [],
        sortInfo: {
          id: 'state_name',
          dir: 0,
        },
      };

      props.regionType = regionTypes.state;
      props.countryId = countryId;

      const { data } = await listRegions(props);

      setDataStates(data?.states);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }
  };

  const fetchDataAreas = async (stateId) => {
    setDataAreas([]);

    try {
      const props = {
        limit: -1,
        offset: 0,
        filterValue: [],
        sortInfo: {
          id: 'area_name',
          dir: 0,
        },
      };

      props.regionType = regionTypes.area;
      props.stateId = stateId;

      const { data } = await listRegions(props);

      setDataAreas(data?.areas);
    } catch (error) {
      promptMessage(false, `${error?.message}`);
    }
  };

  // const loadInitialCustomFieldState = async () => {

  //     const cf = await getInitialFormStateRows({
  //         savedCustomFields: []
  //     })

  //     setFieldValue(`rows`, cf)
  // }

  // const fetchCustomFields = async ({ fieldModule, moduleFunction }) => {

  //     setSystemLoading(true)

  //     try {

  //         const props = {
  //             limit: -1,
  //             skip: 0,
  //             sortInfo: {
  //                 id: "id",
  //                 dir: 0,
  //             },
  //             filterValue: [
  //                 {
  //                     name: "field_module",
  //                     operator: filterOperatorTypes.eq,
  //                     value: fieldModule
  //                 },
  //                 {
  //                     name: "module_function",
  //                     operator: filterOperatorTypes.eq,
  //                     value: moduleFunction
  //                 }
  //             ]
  //         };

  //         const response = await listCustomFields(props);

  //         const _cf = response?.data?.custom_fields
  //         setCustomFields(_cf)

  //         // setCustomFields(response?.data?.custom_fields)

  //         // prepare for getting the input state data by getting the exact value from api
  //         const cf = getInitialFormStateRows({
  //             savedCustomFields: [],
  //             customFields: _cf
  //         })

  //         setFieldValue(`rows`, cf)

  //     } catch (error) {
  //         promptMessage(false, `Action Failed (${error?.message})`)
  //     }

  //     setSystemLoading(false)

  // }

  const formik = useFormik({
    initialValues: initialValuesCombine,
    validationSchema: validationSchemaCombine,
    enableReinitialize: true,
    onSubmit,
  });

  const { values, errors, touched, handleChange, setFieldValue } = formik;

  useEffect(() => {
    fetchDataCountry();
    // loadInitialCustomFieldState()

    // set default values
    setFieldValue(`type`, branchDataTypes.filter((i) => i.default)[0].id);
    setFieldValue(`isHQ`, true);
    setFieldValue(`status`, true);
  }, []);

  useEffect(() => {
    if (formik?.values?.countryId) {
      if (dataStates.length) {
        if (dataStates[0].country_id !== formik.values.countryId) {
          fetchDataStates(formik.values.countryId);
        }
      } else {
        fetchDataStates(formik.values.countryId);
      }
    }

    if (formik?.values?.stateId) {
      if (dataAreas.length) {
        if (dataAreas[0].state_id !== formik.values.stateId) {
          fetchDataAreas(formik.values.stateId);
        }
      } else {
        fetchDataAreas(formik.values.stateId);
      }
    }
  }, [formik.values]);

  const getPostcodesArray = () => {
    let postcodeStringCheck = dataAreas.filter((i) => i.id === formik.values.areaId);

    if (postcodeStringCheck.length <= 0) return [];

    let postcodeString = postcodeStringCheck.length >= 0 ? postcodeStringCheck[0].postcode_string : '';

    let postcodeArray = postcodeString.includes(',') ? postcodeString.split(',') : [postcodeString];

    if (postcodeArray.length <= 0) return [];

    return postcodeArray;
  };

  // const RenderCustomFieldSelection = () => {

  //     if (!values?.rows) return <></>

  //     const rows = values.rows

  //     return (
  //         <>
  //             <Grid item xs={12}>
  //                 <Divider sx={{ mt: 2, mb: 1 }} />
  //             </Grid>

  //             <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
  //                 <CommonSectionHeader
  //                     title='Custom Properties'
  //                     subTitle={"Provide custom item information"}
  //                 />
  //             </Grid>
  //             <Grid item xs={12} sm={12} md={9}>
  //                 <List>
  //                     {
  //                         rows.map((item, index) => {

  //                             let itemValues = item

  //                             let {
  //                                 fieldType,
  //                                 fieldLabel,
  //                                 fieldKey
  //                             } = item

  //                             return (
  //                                 <ListItem
  //                                     key={index}
  //                                     divider
  //                                     disablePadding
  //                                     sx={{
  //                                         py: 1
  //                                     }}
  //                                 >
  //                                     <Grid container spacing={1}>
  //                                         <Grid item md={3} xs={12} sm={12} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} >
  //                                             <Chip
  //                                                 label={fieldLabel}
  //                                                 color='primary'
  //                                                 variant='outlined'
  //                                                 size='large'
  //                                                 // avatar={<CommonIcons name={icons.add} />}
  //                                                 sx={{
  //                                                     width: '100%',
  //                                                     // textAlign: 'left',
  //                                                     fontSize: 16,
  //                                                     fontWeight: 800
  //                                                 }}
  //                                             />
  //                                         </Grid>
  //                                         <Grid item md={9} xs={12} sm={12}>

  //                                             {
  //                                                 fieldType === inputTypesDef.textbox &&

  //                                                 RenderCustomFieldSelectionTextbox({
  //                                                     index,
  //                                                     item,
  //                                                     itemValues,
  //                                                     inputProps: {
  //                                                         fullWidth: true,
  //                                                         name: `rows.${index}.customValue`,
  //                                                         label: itemValues?.fieldLabel,
  //                                                         type: "text",
  //                                                         variant: "outlined",
  //                                                         value: itemValues?.customValue,
  //                                                         onChange: (event) => setFieldValue(`rows.${index}.customValue`, event.target.value),
  //                                                     }
  //                                                 })
  //                                             }

  //                                             {
  //                                                 fieldType === inputTypesDef.dropdown &&

  //                                                 RenderCustomFieldSelectionDropdown({
  //                                                     index,
  //                                                     item,
  //                                                     itemValues,
  //                                                     selectProps: {
  //                                                         labelId: "customValue",
  //                                                         label: itemValues?.fieldLabel,
  //                                                         name: `rows.${index}.customArray`,
  //                                                         onChange: (event) => {
  //                                                             setFieldValue(`rows.${index}.customArray`, [event.target.value])
  //                                                         },
  //                                                         size: 'small',
  //                                                         margin: 'dense',
  //                                                         value: itemValues.customArray.length ? itemValues.customArray[0] : ""
  //                                                     }
  //                                                 })
  //                                             }

  //                                             {
  //                                                 fieldType === inputTypesDef.multidropdown &&

  //                                                 RenderCustomFieldSelectionMultiDropdown({
  //                                                     index,
  //                                                     item,
  //                                                     itemValues,
  //                                                     selectProps: {
  //                                                         labelId: itemValues?.fieldLabel,
  //                                                         label: itemValues?.fieldLabel,
  //                                                         name: `rows.${index}.customArray`,
  //                                                         onChange: handleChange,
  //                                                         renderValue: (selected) => {

  //                                                             return (
  //                                                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
  //                                                                     {
  //                                                                         getCustomFieldOptionNameByIds(selected, dataCustomFields, fieldKey).map((i, index) => (
  //                                                                             <Chip
  //                                                                                 key={index}
  //                                                                                 // color={'red'}
  //                                                                                 label={spliceString({ val: i, maxLength: 20 })}
  //                                                                             />
  //                                                                         ))
  //                                                                     }
  //                                                                 </Box>
  //                                                             )

  //                                                         },
  //                                                         size: 'small',
  //                                                         margin: 'dense',
  //                                                         multiple: true,
  //                                                         input: <OutlinedInput id="select-multiple-chip" label="Chip" />,
  //                                                         value: itemValues?.customArray ? itemValues.customArray : []
  //                                                     }
  //                                                 })
  //                                             }

  //                                         </Grid>
  //                                     </Grid>
  //                                 </ListItem>
  //                             )

  //                         })
  //                     }

  //                 </List>

  //             </Grid>
  //         </>
  //     )
  // }

  const handleMarkingAddItem = ({ rows, setFieldValue }) => {
    rows.push(initialRowValues);
    setFieldValue('rows', rows);
  };

  const handleMarkingRemoveItem = ({ rows, index, setFieldValue }) => {
    const currentLine = rows ? rows.length : 0;

    if (currentLine <= 1) {
      promptMessage(false, t('itemsAtLeastHave1Row'));
      return false;
    }

    const newRows = rows.filter((i, ind) => ind !== index);

    // rows.remove(index);
    setFieldValue('rows', newRows);

    return true;
  };

  const RenderMarkingRow = () => {
    const rows = values?.rows;

    return (
      <Box>
        <Box>
          {rows &&
            rows.length > 0 &&
            rows.map((item, index) => {
              const itemValues = item;
              let itemTouched = touched?.rows;
              let itemErrors = errors?.rows;
              // const itemTouched = touched?.rows

              if (itemTouched) {
                itemTouched = itemTouched[index] !== undefined ? itemTouched[index] : {};
              }

              if (itemErrors) {
                itemErrors = itemErrors[index] !== undefined ? itemErrors[index] : {};
              }

              return (
                <Grid key={index} item xs={12} sm={12} md={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={0.5} alignContent={'center'}>
                      <IconButton
                        sx={{
                          mb: 2,
                        }}
                        aria-label="delete"
                        onClick={() => handleMarkingRemoveItem({ rows: values.rows, index, setFieldValue })}
                      >
                        <CommonIcons name={icons.remove} />
                      </IconButton>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                      <TextField
                        margin="dense"
                        size="small"
                        fullWidth
                        name={`rows.${index}.marking`}
                        label={t('marking')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.marking ? itemValues.marking : ''}
                        onChange={(e) => {
                          setFieldValue(`rows.${index}.marking`, e.target.value);
                          setFieldValue(`marking`, '');
                        }}
                        error={Boolean(itemErrors?.marking)}
                        helperText={itemErrors?.marking}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
        </Box>
      </Box>
    );
  };

  const RenderMarkingItemInfo = () => {
    return (
      <>
        <Grid item xs={12} sm={12} md={3} textAlign={'left'}>
          <CommonSectionHeader title={t('markingInfo')} subTitle={t('detailsOfMarkingInformation')} />
        </Grid>

        <Grid item xs={12} sm={12} md={8.5}>
          {RenderMarkingRow()}
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
          <></>
        </Grid>

        <Grid item xs={12} sm={12} md={4.5} textAlign={'right'}>
          <Button
            variant="outlined"
            sx={{
              mt: 1,
            }}
            fullWidth
            startIcon={<CommonIcons name={icons.add} />}
            onClick={() => handleMarkingAddItem({ rows: values.rows, setFieldValue })}
          >
            {t('addMarking')}
          </Button>
        </Grid>
      </>
    );
  };

  const RenderFormProfile = () => {
    return (
      <>
        <Grid item xs={12} sm={12} md={3} textAlign={'left'}>
          <CommonSectionHeader title={t('customerProfile')} subTitle={t('fullDetailsOfCustomerInformation')} />
        </Grid>
        <Grid item xs={12} sm={12} md={9}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'firstname'}
                label={t('firstName')}
                type="text"
                variant="outlined"
                value={values.firstname}
                onChange={handleChange}
                error={touched.firstname && Boolean(errors.firstname)}
                helperText={touched.firstname && errors.firstname}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'lastname'}
                label={t('lastName')}
                type="text"
                variant="outlined"
                value={values.lastname}
                onChange={handleChange}
                error={touched.lastname && Boolean(errors.lastname)}
                helperText={touched.lastname && errors.lastname}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'companyname'}
                label={t('companyName')}
                type="text"
                variant="outlined"
                value={values.companyname}
                onChange={handleChange}
                error={touched.companyname && Boolean(errors.companyname)}
                helperText={touched.companyname && errors.companyname}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'regno'}
                label={t('regNo')}
                type="text"
                variant="outlined"
                value={values.regno}
                onChange={handleChange}
                error={touched.regno && Boolean(errors.regno)}
                helperText={touched.regno && errors.regno}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'code'}
                label={t('code')}
                type="text"
                variant="outlined"
                value={values.code}
                onChange={handleChange}
                error={touched.code && Boolean(errors.code)}
                helperText={touched.code && errors.code}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'accountcode'}
                label={t('accountCode')}
                type="text"
                variant="outlined"
                value={values.accountcode}
                onChange={handleChange}
                error={touched.accountcode && Boolean(errors.accountcode)}
                helperText={touched.accountcode && errors.accountcode}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'email'}
                label={t('email')}
                type="email"
                variant="outlined"
                value={values.email}
                onChange={handleChange}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'contactno'}
                label={t('contact')}
                type="text"
                variant="outlined"
                value={values.contactno}
                onChange={handleChange}
                error={touched.contactno && Boolean(errors.contactno)}
                helperText={touched.contactno && errors.contactno}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'salesperson'}
                label={t('salesperson')}
                type="text"
                variant="outlined"
                value={values.salesperson}
                onChange={handleChange}
                error={touched.salesperson && Boolean(errors.salesperson)}
                helperText={touched.salesperson && errors.salesperson}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'remark'}
                label={t('remark')}
                type="text"
                multiline
                rows={3}
                variant="outlined"
                value={values.remark}
                onChange={handleChange}
                error={touched.remark && Boolean(errors.remark)}
                helperText={touched.remark && errors.remark}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  const RenderFormAuth = () => {
    return (
      <>
        <Grid item xs={12} sm={12} md={3} textAlign={'left'}>
          <CommonSectionHeader title={t('credential')} subTitle={t('accessAuthentication')} />
        </Grid>
        <Grid item xs={12} sm={12} md={9}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                autoFocus
                fullWidth
                name={'username'}
                label={t('username')}
                type="text"
                variant="outlined"
                value={values.username}
                onChange={handleChange}
                error={touched.username && Boolean(errors.username)}
                helperText={touched.username && errors.username}
              />
            </Grid>
            <Grid item xs={12} md={6} textAlign="left">
              <></>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'password'}
                label={t('password')}
                type="password"
                variant="outlined"
                value={values.password}
                onChange={handleChange}
                error={touched.password && Boolean(errors.password)}
                helperText={touched.password && errors.password}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'passwordconfirm'}
                label={t('confirmPassword')}
                type="password"
                variant="outlined"
                value={values.passwordconfirm}
                onChange={handleChange}
                error={touched.passwordconfirm && Boolean(errors.passwordconfirm)}
                helperText={touched.passwordconfirm && errors.passwordconfirm}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  const RenderFormBranchProfile = () => {
    const rows = values.rows;

    let availableMarking = rows.filter((i) => i?.marking);

    return (
      <>
        {/* New Branch */}
        <Grid item xs={12} sm={12} md={3} textAlign={'left'}>
          <CommonSectionHeader title={t('mainBranchProfile')} subTitle={t('mainBranchProfileDetailsInformation')} />
        </Grid>

        <Grid item xs={12} sm={12} md={9}>
          <Grid container spacing={1}>
            {/* <Grid item xs={12} md={12} textAlign="left"> */}
            {/* <FormControlLabel 
                                control={
                                    <Switch 
                                        name="status" 
                                        checked={Boolean(values.isHQ)}
                                        onChange={(event, checked) => {
                                            setFieldValue("isHQ", checked);
                                        }}
                                    />
                                } 
                                label={
                                    Boolean(values.isHQ)? "Is HQ" : "No HQ"
                                }
                            /> */}
            <></>
            {/* </Grid> */}

            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'branchName'}
                label={t('branchName')}
                type="text"
                variant="outlined"
                value={values.branchName}
                onChange={handleChange}
                error={touched.branchName && Boolean(errors.branchName)}
                helperText={touched.branchName && errors.branchName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'branchCode'}
                label={t('branchCode')}
                type="text"
                variant="outlined"
                value={values.branchCode}
                onChange={handleChange}
                error={touched.branchCode && Boolean(errors.branchCode)}
                helperText={touched.branchCode && errors.branchCode}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'branchContact'}
                label={t('branchContact')}
                type="text"
                variant="outlined"
                value={values.branchContact}
                onChange={handleChange}
                error={touched.branchContact && Boolean(errors.branchContact)}
                helperText={touched.branchContact && errors.branchContact}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'branchEmail'}
                label={t('branchEmail')}
                type="email"
                variant="outlined"
                value={values.branchEmail}
                onChange={handleChange}
                error={touched.branchEmail && Boolean(errors.branchEmail)}
                helperText={touched.branchEmail && errors.branchEmail}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'picName'}
                label={t('contactName')}
                type="text"
                variant="outlined"
                value={values.picName}
                onChange={handleChange}
                error={touched.picName && Boolean(errors.picName)}
                helperText={touched.picName && errors.picName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'picContact'}
                label={t('contactNo')}
                type="text"
                variant="outlined"
                value={values.picContact}
                onChange={handleChange}
                error={touched.picContact && Boolean(errors.picContact)}
                helperText={touched.picContact && errors.picContact}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'picEmail'}
                label={t('contactEmail')}
                type="email"
                variant="outlined"
                value={values.picEmail}
                onChange={handleChange}
                error={touched.picEmail && Boolean(errors.picEmail)}
                helperText={touched.picEmail && errors.picEmail}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              {/* {JSON.stringify(rows)} */}
              <FormControl margin="dense" fullWidth size="small" error={touched.marking && Boolean(errors.marking)}>
                <InputLabel id="marking">{t('branchMarking')}</InputLabel>
                <Select
                  labelId="marking"
                  label={t('branchMarking')}
                  name={'marking'}
                  onChange={(event) => {
                    setFieldValue('marking', event.target.value);
                  }}
                  value={values.marking}
                // value={
                //     checkValueExists({
                //         dataSearch: availableMarking,
                //         valueToCompare: values.marking
                //     })
                // }
                >
                  {availableMarking.map((i, index) => {
                    return (
                      <MenuItem key={index} value={i.marking}>
                        {i.marking}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>{touched.marking && errors.marking}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'remark'}
                label={t('remark')}
                type="text"
                multiline
                rows={3}
                variant="outlined"
                value={values.remark}
                onChange={handleChange}
                error={touched.remark && Boolean(errors.remark)}
                helperText={touched.remark && errors.remark}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  const RenderFormBranchAdditional = () => {
    return (
      <>
        {/* New Branch */}
        <Grid item xs={12} sm={12} md={3} textAlign={'left'}>
          <CommonSectionHeader title={t('mainBranchAddress')} subTitle={t('mainBranchAddressDetailsinformation')} />
        </Grid>

        <Grid item xs={12} sm={12} md={9}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl margin="dense" fullWidth size="small" error={touched.type && Boolean(errors.type)}>
                <InputLabel id="type">{t('branchType')}</InputLabel>
                <Select
                  disabled
                  labelId="type"
                  label={t('branchType')}
                  name={'type'}
                  // onChange={
                  //     (event) =>{
                  //         setFieldValue("type",event.target.value)
                  //     }
                  // }
                  value={values.type}
                >
                  {branchDataTypes.map((i, index) => {
                    return (
                      <MenuItem key={index} value={i.id}>
                        {i.display}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>{touched.type && errors.type}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <></>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'address1'}
                label={t('address1')}
                type="text"
                variant="outlined"
                value={values.address1}
                onChange={handleChange}
                error={touched.address1 && Boolean(errors.address1)}
                helperText={touched.address1 && errors.address1}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                margin="dense"
                size="small"
                fullWidth
                name={'address2'}
                label={t('address2')}
                type="text"
                variant="outlined"
                value={values.address2}
                onChange={handleChange}
                error={touched.address2 && Boolean(errors.address2)}
                helperText={touched.address2 && errors.address2}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <FormControl margin="dense" fullWidth size="small" error={touched.countryId && Boolean(errors.countryId)}>
                <InputLabel id="country">{t('country')}</InputLabel>
                <Select
                  labelId="countryId"
                  label={t('country')}
                  name={'countryId'}
                  onChange={(event) => {
                    setFieldValue(`countryId`, event.target.value);
                    setFieldValue(`stateId`, '');
                    setFieldValue(`areaId`, '');
                    setDataStates([]);
                    setDataAreas([]);
                  }}
                  value={checkValueExists({
                    dataSearch: dataCountries,
                    valueToCompare: values.countryId,
                  })}
                >
                  {dataCountries.map((i, index) => {
                    return (
                      <MenuItem key={index} value={i.id}>
                        {i.country_name}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>{touched.countryId && errors.countryId}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <FormControl margin="dense" fullWidth size="small" error={touched.stateId && Boolean(errors.stateId)}>
                <InputLabel id="state">{t('state')}</InputLabel>
                <Select
                  labelId="stateId"
                  label={t('state')}
                  name={'stateId'}
                  onChange={(event) => {
                    setFieldValue(`stateId`, event.target.value);
                    setFieldValue(`areaId`, '');
                    setDataAreas([]);
                  }}
                  value={checkValueExists({
                    dataSearch: dataStates,
                    valueToCompare: values.stateId,
                  })}
                >
                  {dataStates.map((i, index) => {
                    return (
                      <MenuItem key={index} value={i.id}>
                        {i.state_name}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>{touched.stateId && errors.stateId}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <FormControl margin="dense" fullWidth size="small" error={touched.areaId && Boolean(errors.areaId)}>
                <InputLabel id="area">{t('area')}</InputLabel>
                <Select
                  labelId="areaId"
                  label={t('area')}
                  name={'areaId'}
                  onChange={handleChange}
                  value={checkValueExists({
                    dataSearch: dataAreas,
                    valueToCompare: values.areaId,
                  })}
                >
                  {dataAreas.map((i, index) => {
                    return (
                      <MenuItem key={index} value={i.id}>
                        {i.area_name}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>{touched.areaId && errors.areaId}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <FormControl margin="dense" fullWidth size="small" error={touched.postcode && Boolean(errors.postcode)}>
                <InputLabel id="postcode">{t('postcode')}</InputLabel>
                <Select
                  labelId="postcode"
                  label={t('postcode')}
                  name={'postcode'}
                  onChange={handleChange}
                  value={values.postcode}
                >
                  {getPostcodesArray().length ? (
                    getPostcodesArray().map((i, index) => {
                      return (
                        <MenuItem key={index} value={i}>
                          {i}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem value={''}>{null}</MenuItem>
                  )}
                </Select>
                <FormHelperText>{touched.postcode && errors.postcode}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  const RenderForm = () => {
    return (
      <form onSubmit={formik.handleSubmit}>
        <StyledCard>
          <Grid container spacing={0}>
            {RenderFormAuth()}

            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>

            {RenderFormProfile()}

            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>

            {RenderMarkingItemInfo()}

            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>

            {RenderFormBranchProfile()}

            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>

            {RenderFormBranchAdditional()}

            {/* {
                            RenderCustomFieldSelection()
                        } */}
          </Grid>
        </StyledCard>
        <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
          <Grid item md={12} textAlign={'right'}>
            <Button
              type="submit"
              // fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
              }}
            // loading={isLoading}
            >
              {t('saveChanges')}
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  };

  return (
    <Box>
      {getHtmlHead({ routeType, title: headTitles.newCustomer })}

      <CommonBreadcumbs
        routeType={routeType}
        pageTitle={t('newCustomer')}
        breadcrumbs={[
          {
            displayText: t('customers'),
            props: {
              href: getRoute(`users/customers`),
            },
          },
          {
            displayText: `${t('newCustomer')} (*)`,
            props: {
              color: 'secondary.main',
            },
          },
        ]}
      />

      {isPermissionAllow({ functionType: functionTypes.pageNew.id }) ? RenderForm() : <CommonRestricted />}
    </Box>
  );
}
